// extracted by mini-css-extract-plugin
export default {"sectionDivider":"SectionDivider_sectionDivider__6K2rZ","text":"SectionDivider_text__9-Zng","line":"SectionDivider_line__wgDt0"};